import { isDebugEnabled } from './debug';

const API_URL = (import.meta.env.VITE_API_URL || 'http://localhost:3003').replace(/\/$/, '');

export interface RoomCheckResult {
  exists: boolean;
  roomId: string;
  adminId: string | null;
  isProtected: boolean;
  isActive: boolean;
  isQueueOpen?: boolean;
  isPublic?: boolean;
  countdownSeconds?: number;
  maxMessages?: number;
}

export async function checkRoom(roomId: string): Promise<RoomCheckResult> {
  const url = `${API_URL}/api/rooms/${encodeURIComponent(roomId)}/metadata`;
  if (isDebugEnabled('room') || isDebugEnabled('all')) {
    console.log('[checkRoom] fetching', url);
  }

  let lastError: Error | undefined;
  for (let attempt = 1; attempt <= 3; attempt++) {
    try {
      const res = await fetch(url, { method: 'GET' });
      if (res.status === 404) {
        return {
          exists: false,
          roomId,
          adminId: null,
          isProtected: false,
          isActive: false,
        };
      }
      if (!res.ok) {
        throw new Error(`room service returned ${res.status}`);
      }
      const data = await res.json();
      if (isDebugEnabled('room') || isDebugEnabled('all')) {
        console.log('[checkRoom] response', data);
      }
      return {
        exists: true,
        roomId: data.roomId || roomId,
        adminId: data.adminId || null,
        isProtected: !!data.isProtected,
        isActive: data.isActive !== false,
        isQueueOpen: !!data.isQueueOpen,
        isPublic: !!data.isPublic,
        countdownSeconds: typeof data.countdownSeconds === 'number' ? data.countdownSeconds : undefined,
        maxMessages: typeof data.maxMessages === 'number' ? data.maxMessages : undefined,
      };
    } catch (err) {
      lastError = err instanceof Error ? err : new Error(String(err));
      if (isDebugEnabled('room') || isDebugEnabled('all')) {
        console.log('[checkRoom] attempt failed', { attempt, error: lastError.message });
      }
      if (attempt < 3) {
        await new Promise((r) => setTimeout(r, 1000 * attempt));
      }
    }
  }

  throw lastError || new Error('room check failed');
}
